import { useFetchSubscriptionEventsQuery } from "../../../../../../redux/queries"
import If from "../../../../if"
import Tooltip from "../../../../tool-tip"

interface Props {
  id: string
}

const EngagementsEvents = ({ id }: Props) => {
  const { data: events, isFetching } = useFetchSubscriptionEventsQuery(
    { subscription_id: id },
    { skip: !id }
  )

  // Loop and set the count of each type of SubscriptionEvents
  let rateAlertEmailOpenCount = 0
  let dashboardPageviewCount = 0

  events?.forEach(event => {
    switch (event.type) {
      case "dashboard_pageview":
        dashboardPageviewCount++
        break

      case "rate_alert_email_open":
        rateAlertEmailOpenCount++
        break

      default:
        break
    }
  })

  const eventCount = dashboardPageviewCount + rateAlertEmailOpenCount
  return (
    <If
      isLoading={isFetching}
      loaderSize={4}
      loaderClassName="py-1 px-1 ml-2"
      condition={eventCount > 0}
      then={
        <Tooltip
          displayTextClass="justify-self-start ml-1"
          toolTipNode={<span>🔥 {eventCount}+</span>}
          text={
            <ul className="text-[10px]">
              <If
                condition={dashboardPageviewCount > 0}
                then={
                  <li>
                    <span className="inline-block mr-1 -rotate-90">🧲</span>{" "}
                    Dashboard pageview {dashboardPageviewCount}x
                  </li>
                }
              />
              <If
                condition={rateAlertEmailOpenCount > 0}
                then={
                  <li>
                    <span className="inline-block mr-1">📧</span> Rate alert
                    opened {dashboardPageviewCount}x
                  </li>
                }
              />
            </ul>
          }
          placement="top"
        />
      }
    />
  )
}

export default EngagementsEvents
